<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let cancel = 'Cancel'
  export let confirm = 'Confirm'
  export let showCancel = true
  export let showConfirm = true
  export let cancelDisabled = false
  export let confirmDisabled = false
</script>

<style>
  .buttons {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
  }
  button {
    padding: 6px 16px;
    border-radius: 2px;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
  }

  .cancel {
    background: white;
    border: 1px solid #6f757c;
  }

  .cancel[disabled] {
    border-color: #999;
  }

  .confirm {
    background: #007bb3;
    border: none;
    color: white;
  }

  .confirm[disabled] {
    background: #cbcacb;
  }

</style>

<div class="buttons">
  {#if showCancel}
    <button  data-cy="cancel-button"  disabled={cancelDisabled} class="cancel" on:click={() => dispatch('cancel')}>
      {cancel}
    </button>
  {/if}
  {#if showConfirm}
    <button data-cy="confirm-button" disabled={confirmDisabled} class="confirm" on:click={() => dispatch('confirm')}>
      {confirm}
    </button>
  {/if}
</div>